/**
 * Created by ZhaoYao on 2022/2/22
 * Desc: 交费服务列表item
 */

import React, { Component } from 'react'

export default class PayChargeRecordItem extends Component {

  constructor () {
    super()

    this.state = {}
  }

  componentDidMount () {

  }

  componentWillUnmount () {

  }

  render () {
    const { rechargeBean } = this.props
    return (
      <div className='recharge-record-item-root'>
        <div style={{ flex: 2, padding: '0 4px' }}>缴费{rechargeBean.ct_payAmount}元
        </div>
        <div style={{ flex: 2, padding: '0 4px' }}>{rechargeBean.ct_method}</div>
        <div style={{
          flex: 3,
          textAlign: 'right',
          padding: '0 4px',
        }}>{rechargeBean.ct_payDate}</div>
      </div>
    )
  }
}
